<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Fee
    </button>
    <a-modal v-model="visible" title="Add a new fee">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Add Fee</a-button>
      </template>

      <a-form class="mb-4" :form="form">
        <a-form-item label="Name">
          <a-input
            placeholder="Name"
            v-decorator="['name', {rules: [{ required: true, message: 'Please input fee name!' }, {max: 50, message: 'Must not exceed 50 characters!'}]}]"
          />
        </a-form-item>
        <a-form-item label="Category">
          <a-select
            v-decorator="['category', {rules: [{ required: true, message: 'Please select a category!' }]}]"
            placeholder="Select category"
          >
            <a-select-option v-for="category in categories" :key="category" :value="category">
              {{ category }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Description">
          <a-textarea
            placeholder="Description"
            v-decorator="['description', {rules: [{ required: false, message: 'Please input fee name!' }, {max: 300, message: 'Must not exceed 300 characters!'}]}]"
          />
        </a-form-item>
        <a-form-item
          label="Type"
        >
          <a-radio-group
            v-decorator="[
              'type',
              {rules: [{ required: true, message: 'Please select a type!' }],
              initialValue: 1 },
            ]"
          >
            <a-radio v-for="feeType in feeTypes" :value="feeType.value" :key="feeType.value" class="mr-2">
              <span class="text-bold">{{feeType.name}}</span>
            </a-radio>
          </a-radio-group>
        </a-form-item>

        <div class="row mb-0">
          <div class="col-md-4 mb-2">
            <a-form-item label="Fine Mode">
              <a-select style="width:150px" v-model="fineMode"
                        placeholder="Select fine mode">
                <a-select-option value="0">Select fine mode</a-select-option>
                <a-select-option value="1">Fixed</a-select-option>
                <a-select-option value="2">Daily Increment</a-select-option>
                <a-select-option value="3">Weekly Increment</a-select-option>
                <a-select-option value="4">Monthly Increment</a-select-option>
                <a-select-option value="5">Quarterly Increment</a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-md-4 mb-2">
            <a-form-item label="Fine Type">
              <a-select style="width:150px" v-model="fineType">
                <a-select-option value="1">Amount</a-select-option>
                <a-select-option value="2">Percentage</a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-md-4 mb-2" v-if="fineType === '1'">
            <a-form-item class="mb-0" label="Fine Amount">
              <div style="width:120px;">
                <a-input-number
                  placeholder="Fine amount"
                  v-decorator="[`fine`, {rules: [{ required: false, message: 'Please input fee amount!' }]}]"
                  :initialValue="0"
                  :min="0"
                  :formatter="value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
                  style="width:100%;"
                />
              </div>
            </a-form-item>
          </div>
          <div class="col-md-4 mb-2" v-if="fineType === '2'">
            <a-form-item class="mb-0" label="Fine %">
              <div style="width:120px;">
                <a-input-number
                  placeholder="Fine %"
                  v-decorator="[`fine`, {rules: [{ required: false, message: 'Please input fee amount!' }]}]"
                  :initialValue="0"
                  :min="0"
                  :max="100"
                  :formatter="value => `${value}%`"
                  :parser="value => value.replace(/\%\s?|(,*)/g, '')"
                  style="width:100%;"
                />
              </div>
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { feeTypes } from '@/services/globaldata'

export default {
  name: 'AddFee',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      feeTypes,
      categories: [],
      fineType: '1',
      fineMode: '0',
    }
  },
  methods: {
    getFeeCategories() {
      this.$http.get('/api/fee/categories').then(({ data }) => {
        this.categories = data.data
      })
    },
    showModal() {
      this.visible = true
      this.getFeeCategories()
    },

    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        console.log(values)
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to add ${values.name}?`,
            content: `Click on the OK button to add the new plan!`,
            onOk: () => {
              this.$http
                .post('/api/fee', {
                  name: values.name,
                  description: values.description,
                  type: values.type,
                  fine_mode: this.fineMode,
                  fine_type: this.fineType,
                  fine: values.fine,
                  category: values.category,
                })
                .then(({ data }) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Plan successfully added',
                    description: `${data.data.name} added successfully!`,
                  })
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
    },
  },
}
</script>
